import FiltersOnMap from "./FiltersOnMap"

export default  FiltersOnMap;



// WEBPACK FOOTER //
// ./src/components/App/FiltersOnMap/index.js